import validate from "/home/runner/work/web-frontend/web-frontend/node_modules/.pnpm/nuxt@4.1.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3._2gjlkbomwb6lnrg4ldn6ahai3y/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45global from "/home/runner/work/web-frontend/web-frontend/app/middleware/route.global.ts";
import manifest_45route_45rule from "/home/runner/work/web-frontend/web-frontend/node_modules/.pnpm/nuxt@4.1.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3._2gjlkbomwb6lnrg4ldn6ahai3y/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}